var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 166,
    viewBox: "0 0 166 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.6329 15.3348L146.425 48.189C148.15 49.0506 149.602 50.3762 150.616 52.0171C151.63 53.658 152.167 55.5491 152.165 57.4781V67.438C152.165 72.2105 148.292 76.0839 143.52 76.0839H138.332V131.417H145.249C147.083 131.417 148.842 132.146 150.14 133.443C151.437 134.74 152.165 136.499 152.165 138.334C152.165 140.168 151.437 141.928 150.14 143.225C148.842 144.522 147.083 145.251 145.249 145.251H20.7487C18.9143 145.251 17.155 144.522 15.8579 143.225C14.5607 141.928 13.832 140.168 13.832 138.334C13.832 136.499 14.5607 134.74 15.8579 133.443C17.155 132.146 18.9143 131.417 20.7487 131.417H27.6654V76.0839H22.4779C17.7054 76.0839 13.832 72.2105 13.832 67.438V57.4781C13.832 53.8675 15.6995 50.5475 18.7152 48.6662L78.3576 15.3348C81.2765 13.8754 84.714 13.8754 87.6329 15.3348Z",
    fill: "url(#paint0_linear_6309_20169)",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.0013 41.5C81.1669 41.5 79.4076 42.2287 78.1105 43.5258C76.8134 44.823 76.0846 46.5823 76.0846 48.4167C76.0846 50.2511 76.8134 52.0104 78.1105 53.3075C79.4076 54.6046 81.1669 55.3333 83.0013 55.3333C84.8357 55.3333 86.595 54.6046 87.8921 53.3075C89.1892 52.0104 89.918 50.2511 89.918 48.4167C89.918 46.5823 89.1892 44.823 87.8921 43.5258C86.595 42.2287 84.8357 41.5 83.0013 41.5ZM117.585 76.0833H48.418V131.417H62.2513V89.9167H76.0846V131.417H89.918V89.9167H103.751V131.417H117.585V76.0833Z",
    fill: "#0C7AFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6309_20169",
    x1: 82.9987,
    y1: 14.2402,
    x2: 82.9987,
    y2: 145.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C7AFF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C7AFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankIcon);
export default __webpack_public_path__ + "static/media/BankIcon.30c1f65281d9c082ebb209b58e72eba3.svg";
export { ForwardRef as ReactComponent };